(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-dropby-cta"] && !Shopify.designMode) return;
  try {
    
  /* Covered postcode prefixes:
     Muswell Hill: N10
     East Finchley: N2
     Surrounding N areas: N3, N4, N6, N8, N11, N12, N13, N14, N19, N20, N22
     Enfield: EN1, EN2, EN3, EN4
     Primrose Hill / Camden: NW1, NW3, NW5
     Hampstead / St John's Wood: NW6, NW8
     Mayfair / West End (target area): W1
  */
  var COVERED_PREFIXES = [
    'N2','N3','N4','N6','N8','N10','N11','N12','N13','N14','N19','N20','N22',
    'EN1','EN2','EN3','EN4',
    'NW1','NW3','NW5','NW6','NW8',
    'W1'
  ];

  function parsePostcode(raw) {
    var clean = raw.replace(/\s+/g, '').toUpperCase();
    if (!/^[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2}$/i.test(clean) && !/^[A-Z]{1,2}\d[A-Z\d]?$/i.test(clean)) {
      return null;
    }
    var outward = clean.length > 3 ? clean.slice(0, -3) : clean;
    return outward;
  }

  function formatPostcode(raw) {
    var clean = raw.replace(/\s+/g, '').toUpperCase();
    if (clean.length > 3) {
      return clean.slice(0, -3) + ' ' + clean.slice(-3);
    }
    return clean;
  }

  function isCovered(outward) {
    for (var i = 0; i < COVERED_PREFIXES.length; i++) {
      if (outward === COVERED_PREFIXES[i]) return true;
    }
    return false;
  }

  function checkAvailability(wrapper) {
    var input = wrapper.querySelector('.custom-cta__postcode-input');
    var raw = input.value.trim();
    if (!raw) { input.focus(); return; }

    var outward = parsePostcode(raw);
    if (!outward) {
      input.classList.add('custom-cta__input--error');
      input.focus();
      setTimeout(function() { input.classList.remove('custom-cta__input--error'); }, 600);
      return;
    }

    var formatted = formatPostcode(raw);
    var covered = isCovered(outward);

    /* Set postcode labels on both step 2 and 2b */
    wrapper.querySelectorAll('.custom-cta__confirm-postcode').forEach(function(el) {
      el.textContent = formatted;
    });

    /* Set hidden postcode fields */
    var formBox = wrapper.closest('.custom-cta__form-box');
    formBox.querySelectorAll('.custom-cta__postcode-hidden').forEach(function(el) {
      el.value = formatted;
    });

    /* Show loading state, then result */
    goToStep(wrapper, '1b');
    setTimeout(function() {
      goToStep(wrapper, covered ? 2 : '2b');
    }, 700);
  }

  document.addEventListener('click', function(e) {
    var wrapper;

    /* Step 1 → check: Check Availability */
    var checkBtn = e.target.closest('.custom-cta__check-btn');
    if (checkBtn) {
      wrapper = checkBtn.closest('.custom-cta__form');
      checkAvailability(wrapper);
      return;
    }

    /* Step 2 → 3: Continue to email */
    var contBtn = e.target.closest('.custom-cta__continue-btn');
    if (contBtn) {
      wrapper = contBtn.closest('.custom-cta__form');
      goToStep(wrapper, 3);
      var emailInput = wrapper.querySelector('.custom-cta__email-input');
      if (emailInput) emailInput.focus();
      return;
    }

    /* Back button */
    var backBtn = e.target.closest('.custom-cta__back-btn');
    if (backBtn) {
      wrapper = backBtn.closest('.custom-cta__form');
      var target = backBtn.getAttribute('data-back');
      /* Reset dots */
      wrapper.querySelectorAll('.custom-cta__dot').forEach(function(d) {
        d.classList.remove('custom-cta__dot--active');
      });
      wrapper.querySelector('.custom-cta__dot[data-step="1"]').classList.add('custom-cta__dot--active');
      goToStep(wrapper, parseInt(target));
      var pcInput = wrapper.querySelector('.custom-cta__postcode-input');
      if (pcInput) { pcInput.value = ''; pcInput.focus(); }
      return;
    }
  });

  /* Enter key on postcode input triggers check */
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('.custom-cta__postcode-input');
    if (!input || input.form) return; /* the postcode box inside the direct form is a normal field */
    e.preventDefault();
    var wrapper = input.closest('.custom-cta__form');
    checkAvailability(wrapper);
  });

  /* Auto-format postcode as user types */
  document.addEventListener('input', function(e) {
    var input = e.target.closest('.custom-cta__postcode-input');
    if (!input) return;
    input.value = input.value.toUpperCase();
  });

  /* Real submit: only disable the button. Do NOT preventDefault — Shopify's bootstrap needs
     the real submit event to attach its captcha token. (Was a fetch post until 2026-09-03; it
     was rejected with "Missing CAPTCHA token" on every send.) */
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('.custom-cta__email-form');
    if (!form) return;
    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }
  });

  /* After Shopify's redirect (?contact_posted=true#<form id>) show the thank-you step in the
     box that sent, and after a rejected post reopen the step that carries the error. */
  function restoreCtaState() {
    var qs;
    try { qs = new URLSearchParams(window.location.search); } catch (err) { return; }
    var hash = window.location.hash || '';
    var wrappers = document.querySelectorAll('.custom-cta__form');
    for (var i = 0; i < wrappers.length; i++) {
      var wrapper = wrappers[i];
      var errEl = wrapper.querySelector('[data-cta-error]');
      if (errEl) {
        goToStep(wrapper, errEl.getAttribute('data-cta-error'));
        continue;
      }
      if (qs.get('contact_posted') !== 'true') continue;
      var mine = hash && wrapper.querySelector('form[id="' + hash.slice(1) + '"]');
      if (hash && !mine) continue;
      goToStep(wrapper, 4);
      wrapper.querySelectorAll('.custom-cta__dot').forEach(function(d) { d.classList.add('custom-cta__dot--active'); });
      (function(w) { requestAnimationFrame(function() { try { w.scrollIntoView({ block: 'center' }); } catch (err) {} }); })(wrapper);
    }
    if (hash && /^#DropbyCta/.test(hash)) {
      try { history.replaceState(null, '', window.location.pathname + window.location.search); } catch (err) {}
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreCtaState);
  } else {
    restoreCtaState();
  }

  function goToStep(wrapper, num) {
    var allSteps = wrapper.querySelectorAll('.custom-cta__step');
    var allDots = wrapper.querySelectorAll('.custom-cta__dot');
    allSteps.forEach(function(s) { s.classList.remove('custom-cta__step--active'); });
    var target = wrapper.querySelector('.custom-cta__step[data-step="' + num + '"]');
    if (target) target.classList.add('custom-cta__step--active');
    var stepNum = (num === '2b' || num === '1b') ? 2 : parseInt(num);
    if (num === '1b') stepNum = 1;
    allDots.forEach(function(d) {
      var dStep = parseInt(d.getAttribute('data-step'));
      if (dStep <= stepNum) { d.classList.add('custom-cta__dot--active'); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-dropby-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  /* Show sticky bar only after scrolling past the hero */
  (function() {
    var bar = document.getElementById('dropbyStickyBar');
    if (!bar) return;
    var hero = document.querySelector('.custom-dropby-hero');
    if (!hero) { bar.classList.add('dropby-sticky-cta--visible'); return; }
    var observer = new IntersectionObserver(function(entries) {
      bar.classList.toggle('dropby-sticky-cta--visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    observer.observe(hero);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
